import React, { FC, useEffect, useRef } from 'react'
import { useDeleteContactMutation } from '../../../../../../../core/api/contactApi'
import { ModalConfirmAction } from '../../../../../../common/ModalConfirmAction'
import { DecryptedContact } from '@icure/cardinal-sdk/model.mjs'
import { message, notification } from 'antd'
import { useTranslation } from 'react-i18next'

interface ModalDeleteConsultationProps {
  contact: DecryptedContact
  isVisible: boolean
  onClose: () => void
}

export const ModalDeleteConsultation: FC<ModalDeleteConsultationProps> = ({ contact, isVisible, onClose }) => {
  const { t } = useTranslation()
  const [deleteContact, { isError: isDeleteContactError, error, isSuccess: isContactDeletedSuccessfully, isLoading: isContactDeletingLoading }] = useDeleteContactMutation()

  const [messageApi, messageCtx] = message.useMessage()
  const [notificationApi, notificationCtx] = notification.useNotification()

  const closeTmr = useRef<ReturnType<typeof setTimeout> | null>(null)
  const msgKey = 'delete-consultation'

  const openNotification = (type: 'error', title: string, description: string) => {
    notificationApi.open({
      type,
      message: title,
      description,
      duration: 0,
      key: 'delete-consultation-notif',
    })
    setTimeout(() => notificationApi.destroy('delete-consultation-notif'), 2500)
  }

  useEffect(() => {
    if (isContactDeletingLoading) {
      messageApi.open({ key: msgKey, type: 'loading', content: t('modalDeleteConsultation.deleting'), duration: 0 })
    }

    if (isContactDeletedSuccessfully) {
      messageApi.open({ key: msgKey, type: 'success', content: t('modalDeleteConsultation.deleted') })
      closeTmr.current = setTimeout(onClose, 1500)
    }

    if (isDeleteContactError) {
      messageApi.destroy(msgKey)
      console.log({ error })
      openNotification('error', t('modalDeleteConsultation.cannotDeleteTitle'), t('modalDeleteConsultation.cannotDeleteDesc'))
      closeTmr.current = setTimeout(onClose, 1500)
    }

    return () => {
      if (closeTmr.current) {
        clearTimeout(closeTmr.current)
        closeTmr.current = null
      }
    }
  }, [isContactDeletingLoading, isContactDeletedSuccessfully, isDeleteContactError, messageApi, notificationApi, onClose, t, error])

  return (
    <>
      {messageCtx}
      {notificationCtx}

      <ModalConfirmAction
        title={t('modalDeleteConsultation.modalTitle')}
        description={t('modalDeleteConsultation.modalDescription')}
        yesBtnTitle={t('modalDeleteConsultation.yesBtn')}
        noBtnTitle={t('modalDeleteConsultation.noBtn')}
        onYesClick={() => deleteContact(contact)}
        onNoClick={onClose}
        isVisible={isVisible}
        mode="danger"
      />
    </>
  )
}
